// @flow
import { Environment } from 'relay-runtime';
import { commitMutation, graphql } from 'react-relay';

type ResponseType = {
	ArticleEdit: {
		article: ?{
			id: string,
		},
		error: ?string,
	},
};

const mutation = graphql`
	mutation ArticleEditMutation($input: ArticleEditInput!) {
		ArticleEdit(input: $input) {
			article {
				id
			}
			error
		}
	}
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, id: ?string) => void) {
	commitMutation(environment, {
		mutation: mutation,
		variables: {
			input: params,
		},
		onCompleted: (response: ResponseType, errors) => {
			const r = response.ArticleEdit;
			let temp;
			const articleId = (temp = r === null || r === void 0 ? void 0 : r.article) === null || temp === void 0 ? void 0 : temp.id;
			const error = errors || (r.hasOwnProperty('error') && r.error);
			if (error) {
				console.error('ArticleEditMutation', error);
				callback(error, articleId);
				return;
			}

			callback(null, articleId);
		},
		onError: error => {
			console.log('error mutating');
			console.log(error);
			callback(error, null);
		},
	});
}



// WEBPACK FOOTER //
// src/mutations/ArticleEditMutation.js